// El hook puede devolver un string o el PostgrestError de Supabase;
// toast solo acepta texto, así que lo normalizamos aquí.
export const mensajeError = (e: unknown): string | undefined => {
  if (typeof e === 'string') return e;
  if (typeof e === 'object' && e !== null && 'message' in e) {
    return String((e as { message: unknown }).message);
  }
  return undefined;
};